import type { TerminalReader } from '@/lib/services/terminals/terminals.types'

export const PaymentMethod = {
  CardEntry: 'cardEntry',
  Reader: 'reader',
  Manual: 'manual',
} as const

export type PaymentMethodValue = (typeof PaymentMethod)[keyof typeof PaymentMethod]

export const ManualTenderType = {
  Cash: 'cash',
  Check: 'check',
} as const

export type ManualTenderTypeValue = (typeof ManualTenderType)[keyof typeof ManualTenderType]

export const getDefaultPaymentMethod = (
  terminals: readonly TerminalReader[] = []
): PaymentMethodValue => (terminals.length > 0 ? PaymentMethod.Reader : PaymentMethod.CardEntry)

export const getDefaultTerminalId = (terminals: readonly TerminalReader[] = []): string =>
  terminals[0]?.id || ''

/** The `paymentTarget` a page hands Pay Now, as far as the session key reads it. */
type SessionKeyTarget =
  | { kind: 'cart'; cartId: number | null }
  | { kind: 'sales_order'; salesOrderId: number; cartId: number | null }
  | { kind: 'customer'; customerId: number | null; primarySalesOrderId?: number | null }

interface SessionKeySnapshot {
  id?: number | null
  sales_order_id?: number | null
  customer_id?: number | null
}

export function buildPaymentModalSessionKey({
  mode = null,
  paymentTarget = null,
  cart = null,
  paymentSnapshot = null,
}: {
  mode?: string | null
  paymentTarget?: SessionKeyTarget | null
  cart?: { id: number } | null
  paymentSnapshot?: SessionKeySnapshot | null
} = {}): string {
  if (!mode) {
    return 'closed'
  }

  if (paymentTarget?.kind === 'sales_order') {
    return [
      mode,
      'sales-order',
      paymentTarget.salesOrderId ?? paymentSnapshot?.sales_order_id ?? 'unknown',
      paymentTarget.cartId ?? paymentSnapshot?.id ?? 'cartless',
    ].join(':')
  }

  if (paymentTarget?.kind === 'customer') {
    return [
      mode,
      'customer',
      paymentTarget.customerId ?? paymentSnapshot?.customer_id ?? 'unknown',
      paymentTarget.primarySalesOrderId ?? paymentSnapshot?.sales_order_id ?? 'orderless',
    ].join(':')
  }

  return [mode, 'cart', paymentTarget?.cartId ?? cart?.id ?? 'unknown'].join(':')
}
